import PropTypes from 'prop-types'

import HeadIcon from '@aytm/app/stats/page/question-views/cjc/components/head/HeadIcon'
import HeadOptions from '@aytm/app/stats/page/question-views/cjc/components/head/HeadOptions'

import style from '@aytm/app/stats/page/question-views/cjc/components/head/styles/Head.module.scss'

const EXPORT_OPTIONS = [
  { key: 'conjointPkgs', text: 'Download Ranked List of Packages (CSV)', fileType: 'csv', exportType: 'conjointPkgs' },
  { key: 'conjointDesign', text: 'Download Design Sheet by aytm (CSV)', fileType: 'csv', exportType: 'conjointDesign' }
]

// The Conjoint Express head. Express has no clusters, so the head is just the badge and the
// options row.
const Head = props => (
  <div className={style.head}>
    <div className={style.icon}>
      <HeadIcon />
      <span>Conjoint Express</span>
    </div>

    <HeadOptions {...props} questionType="cjc" exportOptions={EXPORT_OPTIONS} />
  </div>
)

Head.displayName = 'ConjointExpressHead'

Head.propTypes = {
  isLite: PropTypes.bool,
  isSummaryChartView: PropTypes.bool,
  isAwaitingFullSlice: PropTypes.bool,
  showExport: PropTypes.bool,
  fullViewOnly: PropTypes.bool,
  onExport: PropTypes.func,
  onShowBar: PropTypes.func,
  onShowVisual: PropTypes.func
}

export default Head
